import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import useSimilarStyle from "../hooks/useSimilarStyle";
import { formatDiscount, formatPrice } from "../../../../utils/price.utils";
import { getProductPdpUrl } from "../../../../utils/url.utils";


const DiscoverSimilarStyle = () => {
  const { similarStyle, loading, toggleWishlist } = useSimilarStyle();

  return (
    <div className="similar-styles-section">
      <div className="in-mlb">
        {loading ? <Skeleton width={320} height={28} /> : <h2>Discover Similar Styles</h2>}
      </div>

      {loading ? (
        <div className="product-grid">
          {Array(5)
            .fill(0)
            .map((_, idx) => (
              <div className="product-card-dtl" key={idx}>
                <Skeleton height={200} />
                <Skeleton height={20} width={150} style={{ marginTop: 10 }} />
                <Skeleton height={20} width={100} />
              </div>
            ))}
        </div>
      ) : similarStyle.length > 0 ? (
        <div className="product-grid-2">
          {similarStyle.map((item) => (
            <div className="product-card-dtl pointer-crusser" key={item.id}>
              <div className="product-img-box">
                <Link to={getProductPdpUrl(item.product_group_name, item.sku)} target="_blank" rel="noopener noreferrer">
                  <img
                    src={item.media_list?.main?.file || "/placeholder.png"}
                    alt={item.name}
                    title={item.name}
                    className="main_image"
                    loading="lazy"
                  />
                  <img
                    src={item.media_list?.hover?.file || "/placeholder.png"}
                    alt={item.name}
                    title={item.name}
                    className="hover_image"
                  />
                </Link>

                <button className="wishlist-btn_products pointer-crusser" onClick={(e) => toggleWishlist(e, item)}>
                  <Heart
                    color={item.is_wishlisted ? "#FF0000" : "#000"}
                    fill={item.is_wishlisted ? "#FF0000" : "none"}
                    size={20}
                    strokeWidth={2}
                  />
                </button>
              </div>

              <p className="product-title pointer-crusser truncate truncate-similar">
                <Link to={getProductPdpUrl(item.product_group_name, item.sku)} target="_blank" rel="noopener noreferrer">
                  {item.name}
                </Link>
              </p>

              <Link to={getProductPdpUrl(item.product_group_name, item.sku)}>
                <div className="product-price m0002">
                  {formatPrice(item.selling_price)}
                  {item.discount > 0 && (
                    <>
                      <span className="original">
                        {formatPrice(item.mrp)}
                      </span>
                      <span className="discount">
                        {formatDiscount(item.discount)}
                      </span>
                    </>
                  )}
                </div>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <p>No similar styles found.</p>
      )}
    </div>
  );
};

export default DiscoverSimilarStyle;